import React from 'react';
import { ArrowUpRight } from 'react-feather';

/**
 * Student task summary card.
 * @param {{
 *   task: any,
 *   statusLabel: string,
 *   className: string,
 *   onShowDetails: () => void
 * }} props
 */
function TaskCard({ task, statusLabel, className, onShowDetails }) {
  return (
    <div className={className} onClick={onShowDetails} role="button" tabIndex={0}>
      {/* Top row: Title + Status + Arrow */}
      <div className="task-card-top">
        <h4>{task.title || 'Task details not found'}</h4>
        <div className="task-card-top-right">
          <span className="task-points-badge">{task.points || 0} pts</span>
          <span className="task-card-arrow">
            <ArrowUpRight size={18} />
          </span>
        </div>
      </div>

      {/* Bottom row: Due date + Priority-style status */}
      <div className="task-card-bottom">
        {task.due_date && (
          <span className="task-due-date">
            ⏰ {new Date(task.due_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
          </span>
        )}
        {!task.due_date && <span className="task-due-date">📋 Open</span>}
        <span className={`task-priority-pill status-pill-${task.status}`}>
          {task.status === 'not_started' ? 'Not Started' :
            task.status === 'in_progress' ? 'In Progress' :
              task.status === 'pending_approval' ? 'Pending Review' :
                task.status === 'completed' ? 'Completed' :
                  task.status === 'rejected' ? 'Rejected' : statusLabel}
        </span>
      </div>

      {task.rejection_message && (
        <div className="rejection-box">
          <strong>Admin Feedback:</strong> {task.rejection_message}
        </div>
      )}
    </div>
  );
}

export default TaskCard;
